import {Card} from 'components/common/Card'
import {Image} from 'components/common/Image'
import {Button} from 'components/system/Button'
import {useCurrency} from 'providers/EnvironmentProvider'
import {useCallback} from 'react'
import {Ventrata} from 'types'
import {TourDetailsButton} from '../TourDetailsButton'
import {getProductDurationFrom} from '../utils/getProductDurationFrom'
import {CostFrom} from './CostFrom'

type Props = {
  product: Ventrata.Product
  onCheckAvailability: (productId: string) => void
  onShowDetails: (productId: string) => void
}

export const TourCard = ({product, onCheckAvailability, onShowDetails}: Props) => {
  const currency = useCurrency()

  const checkAvailability = useCallback(() => {
    onCheckAvailability(product.id)
  }, [product.id, onCheckAvailability])

  const showDetails = useCallback(() => {
    onShowDetails(product.id)
  }, [product.id, onShowDetails])

  const productDuartionFrom = getProductDurationFrom(product)

  return (
    <div>
      <Card
        className="bg-gray-4 rounded-lg"
        image={<Image src={product.coverImageUrl} title={product.title} />}
        header={
          <div className="flex flex-col">
            <div className="font-bold text-lg">{product.title}</div>
          </div>
        }
        main={
          <div className="flex flex-col">
            {product.shortDescription && (
              <div className="text-text-secondary" dangerouslySetInnerHTML={{__html: product.shortDescription}} />
            )}
            <div className="flex flex-col gap-4 py-4">
              <div className="grid grid-cols-[110px_1fr] gap-y-2">
                <div className="text-text-secondary">Cost from</div>
                <CostFrom product={product} currency={currency} />
                <div className="text-text-secondary">Duration from</div>
                <div className="font-medium">{productDuartionFrom}</div>
              </div>
            </div>

            <div className="flex flex-col d:flex-row gap-3 d:gap-6 items-center">
              <Button.Secondary.Black onClick={checkAvailability} autoExpanded className="!h-[40px]">
                Check Availability
              </Button.Secondary.Black>
              <TourDetailsButton onClick={showDetails} />
            </div>
          </div>
        }
      />
    </div>
  )
}
